module.exports = __webpack_public_path__ + "static/media/tarou.049f296f.png";